import React from 'react';

import Svg from '@bibliocommons/svg';

import Divider from 'app/components/bibs/shared/Divider';

import './BrowseHomePageLoadingStencil.scss';

const BrowseHomePageLoadingStencil = () => {
  return (
    <article className="container cp-browse-home-page-loading-stencil" role="presentation">
      <section className="row">
        <div className="col-lg-8">
          <div className="hero-image"></div>
          <Svg className="pulse hero-title">
            <rect height="100%" width="100%" />
          </Svg>
          <Svg className="pulse hero-title-secondary">
            <rect height="100%" width="100%" />
          </Svg>
        </div>
        <div className="col-lg-4 lists-secondary">
          {Array.from({ length: 3 }).map(() => (
            <div className="row secondary">
              <div className="col-4">
                <div className="secondary-image"></div>
              </div>
              <div className="col-8">
                <Svg className="pulse secondary-title">
                  <rect height="100%" width="100%" />
                </Svg>
                <Svg className="pulse secondary-title-secondary">
                  <rect height="100%" width="100%" />
                </Svg>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Divider />

      <section className="row nav">
        {Array.from({ length: 4 }).map(() => (
          <div className="col-xs-6 col-md-3 nav-col">
            <div className="nav-item">
              <Svg className="pulse nav-item-svg">
                <rect height="100%" width="100%" />
              </Svg>
            </div>
          </div>
        ))}
      </section>
    </article>
  );
};

export default BrowseHomePageLoadingStencil;
